import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL  = 'https://gjtaymsufnlhzyedagdb.supabase.co';
const SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdqdGF5bXN1Zm5saHp5ZWRhZ2RiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE4ODEzNDAsImV4cCI6MjA4NzQ1NzM0MH0.UayxrftBX1ppP-Z1Il5nTXsXY0YNEhm4CKUatvt1q_s';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});
